import { combineReducers } from 'redux';
import tripPage from './tripPage';

const rootReducer = combineReducers({
  tripPage,
});

export default rootReducer;
